import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "sign-in-component",
  class: "fs-5 border-start ps-3 h-100 border-secondary"
}
const _hoisted_2 = { class: "text-danger fw-bold text-uppercase mb-0" }
const _hoisted_3 = { class: "d-flex flex-column w-100" }
const _hoisted_4 = { class: "mt-1 fs-6" }
const _hoisted_5 = ["placeholder"]
const _hoisted_6 = { class: "d-flex align-items-center mt-2" }
const _hoisted_7 = ["placeholder"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.connect), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          type: "email",
          "aria-label": "Username",
          placeholder: _ctx.placeHolderEmail,
          id: "input-email",
          class: "fs-6 pt-0 pb-0 w-100",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.username) = $event))
        }, null, 8, _hoisted_5), [
          [_vModelText, _ctx.username]
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "password",
          "aria-label": "Password",
          placeholder: _ctx.placeHolderPassword,
          id: "input-password",
          class: "fs-6 pt-0 pb-0",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
          onKeyup: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => (_ctx.clickedSignIn && _ctx.clickedSignIn(...args)), ["enter"]))
        }, null, 40, _hoisted_7), [
          [_vModelText, _ctx.password]
        ]),
        _createElementVNode("button", {
          class: "btn btn-danger text-white fs-6 border-0 ms-2 pt-1 pb-1 ps-2 pe-2 text-uppercase",
          type: "submit",
          disabled: _ctx.signInStatus === _ctx.SIGNED_IN_STATUS.RUNNING || (_ctx.username === '' || _ctx.password === ''),
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.clickedSignIn && _ctx.clickedSignIn(...args)))
        }, [
          (_ctx.signInStatus !== _ctx.SIGNED_IN_STATUS.RUNNING)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.buttonSignIn), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_font_awesome_icon, {
                  icon: "spinner",
                  class: "faa-spin animated"
                })
              ]))
        ], 8, _hoisted_8)
      ])
    ]),
    _createElementVNode("h6", {
      class: "text-decoration-underline text-white mt-1 fw-light clickable",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/contact')))
    }, _toDisplayString(_ctx.NoAccount), 1)
  ]))
}